import gql from 'graphql-tag';

export const ReactionsCommentsFragment = gql`
	fragment ReactionsCommentsFragment on ReactionsSummaryResponse {
		ari
		containerAri
		reactionsCount
		reactionsSummaryForEmoji {
			id
			emojiId
			count
			reacted
		}
	}
`;
